module.exports = __webpack_public_path__ + "static/img/govIcon1.d0289dc0.png";